import { useState, useEffect, useCallback } from "react";
import classes from "./classes.module.scss";
import { CheckCircleIcon, XCircleIcon, ExclamationTriangleIcon, InformationCircleIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { EToastType, ToastContent } from "contexts/Toast";
import classNames from "classnames";

type IProps = ToastContent & {
	onClose: () => void;
};

export function Toast({ message, type, onClose }: IProps) {
	const [isExiting, setIsExiting] = useState(false);

	const handleClose = useCallback(() => {
		setIsExiting(true);
		const timer = setTimeout(() => {
			onClose();
		}, 300); // Match animation duration
		return () => clearTimeout(timer);
	}, [onClose]);

	useEffect(() => {
		const timer = setTimeout(() => {
			handleClose();
		}, 3000);
		return () => clearTimeout(timer);
	}, [handleClose]);

	const renderIcon = useCallback(() => {
		switch (type) {
			case EToastType.SUCCESS:
				return <CheckCircleIcon className={classes["icon"]} />;
			case EToastType.ERROR:
				return <XCircleIcon className={classes["icon"]} />;
			case EToastType.WARNING:
				return <ExclamationTriangleIcon className={classes["icon"]} />;
			case EToastType.INFO:
				return <InformationCircleIcon className={classes["icon"]} />;
			default:
				return null;
		}
	}, [type]);

	return (
		<div className={classNames(classes["toast"], classes[`toast-${type}`], { [classes["toast-exiting"]!]: isExiting })}>
			<div className={classes["toast-icon"]}>{renderIcon()}</div>
			<div className={classes["toast-message"]}>{message}</div>
			<button className={classes["toast-close"]} onClick={handleClose}>
				<XMarkIcon className={classes["close-icon"]} />
			</button>
		</div>
	);
}
